import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'bullet',
  templateUrl: './bullet-item.component.html',
  styleUrls: ['./bullet-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BulletItemComponent {
  @Input() active: boolean = true;
}
